import * as React from "react";
import {
    PlasmicListElement,
    DefaultListElementProps
} from "./plasmic/main/PlasmicListElement";

export interface ListElementProps extends DefaultListElementProps {
    name: string,
    selected: boolean,
    action: () => void
}

function ListElement({name, selected, action, ...rest}: ListElementProps) {

    return <PlasmicListElement
        {...rest}
        root={{
            onClick: action
        }}
        selected={selected}
    >
        {name}
    </PlasmicListElement>;
}

export default ListElement;
